import { Component } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-mobile-footer',
    templateUrl: './mobile-footer.component.html',
    styleUrls: ['./mobile-footer.component.scss'],
    standalone: false
})
export class MobileFooterComponent {
  mobileFooterData: any;

  constructor(private component:CmsComponentData<any>,protected config: OccConfig){
    
  }
  
  ngOnInit(){
    this.component.data$.subscribe((data)=>{
      this.mobileFooterData =data;
    })
  }

  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }

}
